import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-locker-info',
  templateUrl: './locker-info.page.html',
  styleUrls: ['./locker-info.page.scss'],
})
export class LockerInfoPage implements OnInit {
  @Input() lockerId: any;
  locker: any;
  conditions = {
    '0': 'Best',
    '1': 'Good',
    '2': 'Fair',
    '3': 'Damaged',
  };
  constructor(
    public modalController: ModalController,
    public dataService: DataService
  ) {}

  ngOnInit() {
   
    this.dataService
      .getData(`lockers/info/${this.lockerId}`)
      .subscribe((res) => {
      
        if (res['locker']) {
          this.locker = res['locker'];
        }
      });
  }

  onCloseModal() {
  
    this.modalController.dismiss();
  }
}
